import { Grid, Box, Typography, TextField, Button } from "@material-ui/core";
import { useMountAPI } from "../hooks/APICall";
import useCustomState from "../hooks/State";
import Call from "../service/API";
import {
  WHITE,
  GREEN_PRIMRY,
  BLUE_COLOR,
  ERROR_COLOR,
  ORANGE_COLOR,
} from "../utils/const";
import Loading6 from "../assets/loading/loading6.gif";
import { useEffect } from "react";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";

const ProjectSettings = (props) => {
  const projectId = props.match.params.projectId;

  const dispatch = useDispatch();

  const projectInfo = useCustomState({});
  const projectInfoIsLoading = useCustomState(true);

  const projectUtils = {
    projectInfo: projectInfo,
    isLoading: projectInfoIsLoading,
    projectId: projectId,
  };

  useMountAPI(fetchProjectInfo, projectUtils);

  useEffect(() => {
    const navigations = [
      { name: "مدیریت پروژه ها", path: "/admin/projects" },
      {
        name: "جزئیات پروژه",
        path: "/admin/project-dash/" + projectId,
        id: projectId,
      },
      { name: "تنظیمات پروژه", path: "#" },
    ];
    dispatch(UpdateNavigations(navigations));
  }, []);

  const registerConsumptionSettingIsLoading = useCustomState(false);
  const registerConsumptionSettingMessage = useCustomState({
    error: false,
    text: "",
  });

  const waterUnit = useCustomState("");
  const powerUnit = useCustomState("");
  const gasUnit = useCustomState("");

  const waterFactor = useCustomState("");
  const powerFactor = useCustomState("");
  const gasFactor = useCustomState("");

  const waterFloat = useCustomState("");
  const powerFloat = useCustomState("");
  const gasFloat = useCustomState("");

  const waterUnitChanged = (e) => {
    waterUnit.handleChange(e.target.value);
  };

  const powerUnitChanged = (e) => {
    powerUnit.handleChange(e.target.value);
  };

  const gasUnitChanged = (e) => {
    gasUnit.handleChange(e.target.value);
  };

  const waterFactorChanged = (e) => {
    waterFactor.handleChange(e.target.value);
  };

  const powerFactorChanged = (e) => {
    powerFactor.handleChange(e.target.value);
  };

  const gasFactorhanged = (e) => {
    gasFactor.handleChange(e.target.value);
  };

  const waterFloatChanged = (e) => {
    waterFloat.handleChange(e.target.value);
  };

  const powerFloatChanged = (e) => {
    powerFloat.handleChange(e.target.value);
  };

  const gasFloatChanged = (e) => {
    gasFloat.handleChange(e.target.value);
  };

  useEffect(() => {
    if (!projectInfoIsLoading.value) {
      const projectInformation =
        projectInfo.value.water_meter_project_other_information;
      if (projectInformation) {
        const settings = projectInformation.settings;
        if (settings) {
          const consumptionValues = settings.consumptionValues;
          if (consumptionValues) {
            console.log(consumptionValues);
            waterUnit.handleChange(consumptionValues.water.unit);
            waterFactor.handleChange(consumptionValues.water.factor);
            waterFloat.handleChange(consumptionValues.water.float);
            powerUnit.handleChange(consumptionValues.power.unit);
            powerFactor.handleChange(consumptionValues.power.factor);
            powerFloat.handleChange(consumptionValues.power.float);
            gasUnit.handleChange(consumptionValues.gas.unit);
            gasFactor.handleChange(consumptionValues.gas.factor);
            gasFloat.handleChange(consumptionValues.gas.float);
          }
        }
      }
    }
  }, [projectInfoIsLoading.value]);

  const registerConsumptionSettings = () => {
    registerConsumptionSettingIsLoading.handleChange(true);
    registerConsumptionSettingMessage.handleChange({ error: false, text: "" });
    const waterSettings = {
      unit: waterUnit.value.length > 0 ? waterUnit.value : "لیتر",
      factor: Number(waterFactor.value) > 0 ? Number(waterFactor.value) : 1,
      float: Number(waterFloat.value) > 0 ? Number(waterFloat.value) : 0,
    };
    const powerSettings = {
      unit: powerUnit.value.length > 0 ? powerUnit.value : "وات ساعت",
      factor: Number(powerFactor.value) > 0 ? Number(powerFactor.value) : 1,
      float: Number(powerFloat.value) > 0 ? Number(powerFloat.value) : 0,
    };
    const gasSettings = {
      unit: gasUnit.value.length > 0 ? gasUnit.value : "مترمکعب",
      factor: Number(gasFactor.value) > 0 ? Number(gasFactor.value) : 1,
      float: Number(gasFloat.value) > 0 ? Number(gasFloat.value) : 0,
    };

    console.log("water settings:  ", waterSettings);
    console.log("power settings: ", powerSettings);
    console.log("gas settings: ", gasSettings);

    const consumptionSettings = {
      water: waterSettings,
      power: powerSettings,
      gas: gasSettings,
    };
    const projectInformation =
      projectInfo.value.water_meter_project_other_information;
    let projectSettings = projectInformation.settings;
    projectSettings = {
      ...projectSettings,
      ...{ consumptionValues: consumptionSettings },
    };
    projectInformation.settings = projectSettings;
    console.log(projectInformation);

    const jsonData = {
      water_meter_project_title: projectInfo.value.water_meter_project_title,
      water_meter_project_name: projectInfo.value.water_meter_project_name,
      water_meter_project_id: projectInfo.value.water_meter_project_id,
      water_meter_project_other_information: projectInformation,
      water_meter_project_start_date:
        projectInfo.value.water_meter_project_start_date,
      water_meter_project_employer_description:
        projectInfo.value.water_meter_project_employer_description,
      water_meter_project_contract_number:
        projectInfo.value.water_meter_project_contract_number,
    };

    const data = new FormData();
    data.append("data", JSON.stringify(jsonData));
    Call("POST", "WaterMeterProjectsURL/admin/edit", data)
      .then((response) => {
        if (response.data.code == 200) {
          registerConsumptionSettingMessage.handleChange({
            error: false,
            text: "اطلاعات با موفقیت ثبت شد.",
          });
        }
        registerConsumptionSettingIsLoading.handleChange(false);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          registerConsumptionSettingMessage.handleChange({
            error: true,
            text:
              "خطای " + data.code + ": " + "مشکلی در ثبت اطلاعات رخ داده است.",
          });
        }
        registerConsumptionSettingIsLoading.handleChange(false);
      });
  };

  const renderLoading = () => {
    if (projectInfoIsLoading.value) {
      return (
        <Grid
          style={{ paddingRight: "24px" }}
          align="center"
          item
          sx={12}
          sm={12}
          md={12}
          lg={12}
        >
          <div
            style={{
              //   maxWidth: "820px",
              width: "260px",
              height: "260px",
              marginTop: "48px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              position: "relative",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <img
              src={Loading6}
              style={{
                width: "180px",
                height: "180px",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
              alt="Loading..."
            />
          </div>
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderWaterConsumptionSettings = () => {
    return (
      <Grid item style={{ paddingRight: "5%", paddingLeft: "5%" }}>
        <Grid
          style={{ fontSize: "14px", color: "#333333" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>واحد مصرف آب </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={waterUnit.value}
              onChange={waterUnitChanged}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: BLUE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>بوده که معادل با </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={waterFactor.value}
              onChange={waterFactorChanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: BLUE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>لیتر است.</Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>و همچنین مقادیر تا </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={waterFloat.value}
              onChange={waterFloatChanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: BLUE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>رقم اعشار نمایش داده شوند.</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderPowerConsumptionSettings = () => {
    return (
      <Grid item style={{ paddingRight: "5%", paddingLeft: "5%" }}>
        <Grid
          style={{ fontSize: "14px", color: "#333333" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>واحد مصرف برق </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={powerUnit.value}
              onChange={powerUnitChanged}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ERROR_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>بوده که معادل با </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={powerFactor.value}
              onChange={powerFactorChanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ERROR_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>وات ساعت است.</Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>و همچنین مقادیر تا </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={powerFloat.value}
              onChange={powerFloatChanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ERROR_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>رقم اعشار نمایش داده شوند.</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderGasConsumptionSettings = () => {
    return (
      <Grid item style={{ paddingRight: "5%", paddingLeft: "5%" }}>
        <Grid
          style={{ fontSize: "14px", color: "#333333" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>واحد مصرف گاز </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={gasUnit.value}
              onChange={gasUnitChanged}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ORANGE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>بوده که معادل با </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={gasFactor.value}
              onChange={gasFactorhanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ORANGE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>مترمکعب است.</Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>و همچنین مقادیر تا </Typography>
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <TextField
              value={gasFloat.value}
              onChange={gasFloatChanged}
              type={"number"}
              style={{ width: "120px" }}
              inputProps={{
                style: {
                  textAlign: "center",
                  color: ORANGE_COLOR,
                },
              }}
            />
          </Grid>
          <Grid style={{ marginLeft: "2px" }} item>
            <Typography>رقم اعشار نمایش داده شوند.</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderConsumptionSettings = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            paddingRight: "5%",
            paddingLeft: "5%",
            marginTop: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #000",
            paddingBottom: "16px",
          }}
        >
          <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
            تنظیمات نمایش مقادیر مصرف
          </Typography>
        </Grid>
        <div style={{ width: "100%" }}>{renderWaterConsumptionSettings()}</div>
        <div style={{ marginTop: "42px", width: "100%" }}>
          {renderPowerConsumptionSettings()}
        </div>
        <div style={{ marginTop: "42px", width: "100%" }}>
          {renderGasConsumptionSettings()}
        </div>
        <Grid container style={{ marginTop: "36px" }}>
          <Grid item style={{ paddingLeft: "5%", paddingRight: "5%" }}>
            <Button
              disabled={registerConsumptionSettingIsLoading.value}
              style={{
                color: WHITE,
                backgroundColor: BLUE_COLOR,
                opacity: registerConsumptionSettingIsLoading.value
                  ? "0.5"
                  : "1",
              }}
              onClick={registerConsumptionSettings}
            >
              ثبت
            </Button>
            <br />
            <br />
            <Typography
              style={{
                display: registerConsumptionSettingIsLoading.value
                  ? "none"
                  : "",
                fontSize: "12px",
              }}
            >
              {registerConsumptionSettingMessage.value.text}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  };

  const renderContent = () => {
    if (projectInfoIsLoading.value) {
      return null;
    } else {
      return (
        <>
          <div
            style={{
              marginTop: "48px",
              width: "100%",
            }}
          >
            <Grid container>{renderConsumptionSettings()}</Grid>
          </div>
        </>
      );
    }
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          style={{
            maxWidth: "250px",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>تنظیمات پروژه</Typography>
        </Box>
        <Grid container>
          {renderLoading()}
          {renderContent()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProjectSettings;

const fetchProjectInfo = (utils) => {
  const projectInfo = utils.projectInfo;
  const isLoading = utils.isLoading;
  const projectId = utils.projectId;

  const data = {
    water_meter_project_id: projectId,
  };

  Call("POST", "WaterMeterProjectsURL/admin/getOne", data)
    .then((response) => {
      console.log(response);
      if (response.data.code === 200) {
        projectInfo.handleChange(response.data.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
      }
      isLoading.handleChange(false);
    });
};
